import {
  isAdmin,
  isPropietario,
  isEspectador,
  isComercial,
  isJefeComerciales,
  isJefeTransportistas,
  isTransportista,
  isGestion,
  isLeads,
} from '../../services/AuthService';

const routePermissions = [
  { path: '/delivery', friendlyName: 'Entregas', roles: [isAdmin, isPropietario, isEspectador, isTransportista, isGestion] },
  { path: '/delivery/dispatch/:id', roles: [isAdmin, isPropietario, isEspectador, isTransportista, isGestion] },
  { path: '/orderItemsByCarrier', friendlyName: 'Artículos a entregar', roles: [isAdmin, isPropietario, isEspectador, isTransportista, isGestion] },

  { path: '/transport', friendlyName: 'Asignación Transportistas', roles: [isAdmin, isPropietario, isEspectador, isJefeTransportistas, isGestion] },
  
  { path: '/calendar', friendlyName: 'Calendario', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },
  { path: '/ordersByCarrier', friendlyName: 'Pedidos por transportista', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/orders', friendlyName: 'Pedidos', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/orders/new', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/orders/:orderId', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion, isLeads] },
  { path: '/orders/:id/related', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/orders-map', friendlyName: 'Mapa de Pedidos', roles: [isAdmin, isPropietario, isEspectador, isGestion, isTransportista] },
  { path: '/zipcode-map', friendlyName: 'Consulta Códigos Postales', roles: [isAdmin, isPropietario, isEspectador, isGestion, isTransportista] },
  { path: '/salesreps/commissions', friendlyName: 'Comisiones', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/carriers/commissions/products', friendlyName: 'Tarifas transportistas', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/carriers/commissions', friendlyName: 'Tarifas', roles: [isAdmin, isPropietario, isEspectador, isTransportista, isGestion] },

  { path: '/clients', friendlyName: 'Clientes', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/clients/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/clients/new', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },

  { path: '/lead-assignment', friendlyName: 'Asignación de Leads', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },
  { path: '/lead-assignment/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },
  { path: '/lead-assignment/new', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },

  { path: '/lead-management', friendlyName: 'Gestión de Leads', roles: [isAdmin, isPropietario, isEspectador, isGestion, isComercial, isJefeComerciales] },

  { path: '/lead-accounts', friendlyName: 'Cuentas de Lead', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/lead-accounts/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/lead-accounts/new', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/daily-lead-stats', friendlyName: 'Estadísticas Diarias', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },

  { path: '/lead-account-history', friendlyName: 'Histórico de Cuentas de Lead', roles: [isAdmin, isPropietario, isEspectador, isGestion, isLeads] },

 
  { path: '/users', friendlyName: 'Usuarios', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/users/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/users/new', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/salesreps', friendlyName: 'Comerciales', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/salesreps/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/salesreps/new', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/carriers', friendlyName: 'Transportistas', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/carriers/edit/:id', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/carriers/new', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/carrier-zip-prefixes', friendlyName: 'Prefijos Transportistas', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/products', friendlyName: 'Productos', roles: [isAdmin, isPropietario, isEspectador, isComercial, isGestion] },
  { path: '/product-variants', friendlyName: 'Variantes de Producto', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/special-products', friendlyName: 'Productos Especiales', roles: [isAdmin, isPropietario, isEspectador, isGestion] },

  { path: '/events', friendlyName: 'Eventos', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/telegram-channel-assignments', friendlyName: 'Canales Telegram', roles: [isAdmin, isPropietario, isEspectador, isGestion] },
  { path: '/logs', friendlyName: 'Logs', roles: [isAdmin] },
  { path: '/analytics', friendlyName: 'Analytics', roles: [isAdmin, isPropietario, isGestion, isEspectador] },

  { path: '/settings', friendlyName: 'Ajustes', roles: [() => true] },
];

export default routePermissions;
